var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.handleScrollThrottled),expression:"handleScrollThrottled"}],staticClass:"c-head--sticky",class:{ 'c-head--vivid': _vm.isMobileMenuExpanded || _vm.isVivid }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }